import { render, staticRenderFns } from "./MailingsRecipientDetails.vue?vue&type=template&id=7bcc27cb&scoped=true&"
import script from "./MailingsRecipientDetails.vue?vue&type=script&lang=ts&"
export * from "./MailingsRecipientDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcc27cb",
  null
  
)

export default component.exports